import { Module, VuexModule, MutationAction, getModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store';

function findModal(modals: any, modalId: string) {
    const modal = modals.find((m: any) => m.id === modalId);
    return modal || {};
}

@Module({
    namespaced: true,
    name: 'ui',
    store,
    dynamic: true,
})
class UIModule extends VuexModule {
    public sidebarStack: string[] = [];
    public modals: object[] = [];
    public componentKeys: Record<string, string> = {
        userstep: 'userstep1',
        invoicestep: 'invoicestep1',
        shippingstep: 'shippingstep1',
        paymentstep: 'paymentstep1',
        view: 'view1',
    };

    get sidebarActive(): string {
        if (!this.sidebarStack) {
            return '';
        }
        return this.sidebarStack[this.sidebarStack.length - 1];
    }

    get isModalVisible(): any {
        // un getter può tornare una funzione se abbiamo bisogno di passare dei parametri
        return (modalId: string) => {
            const modal = this.findModal(modalId);
            return modal ? modal.visible : false;
        };
    }

    get findModal(): any {
        return (modalId: string) => {
            return findModal(this.modals, modalId);
        };
    }

    get sidebarLength(): number {
        return this.sidebarStack.length ;
    }

    @Mutation
    public reloadComponentKeys() {
        for (const key in this.componentKeys) {
            if (this.componentKeys.hasOwnProperty(key)) {
                const k = this.componentKeys[key] as string;
                const m = k.match(/([0-9]+)/g);
                if (m) {
                    const next = parseInt(m[0], 10) + 1;
                    this.componentKeys[key] = k.replace(m[0], next.toString());
                }
            }
        }
    }

    @Mutation
    public pushSidebar(id: string) {
        this.sidebarStack.push(id);
    }

    @Mutation
    public popSidebar() {
        this.sidebarStack.pop();
    }

    @Mutation
    public closeSidebar() {
        this.sidebarStack = [];
    }

    @Mutation
    public newModal(modalId: string) {
        this.modals.push({id: modalId, visible: false});
    }

    @Mutation
    public openModal(modalId: string) {
        const modal = findModal(this.modals, modalId);
        modal.visible = true;
    }

    @Mutation
    public closeModal(modalId: string) {
        const modal = findModal(this.modals, modalId);
        modal.visible = false;
    }
}

export default getModule(UIModule);

